import React, { useState, useEffect } from 'react';
import { _ } from '_locales';
import { connect } from 'react-redux';
import parse from 'html-react-parser';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { colors as fixedColors } from '_styles';

import { zone as zoneSetup } from '_actions';
import { setCollectionSchedule } from '../../utils';

// style
const Container = styled.div`
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    height: auto;
    overflow: hidden;
    min-height: 300px;
`;

const Text = styled.h4`
    font-size: 16px !important;
    color: #000000;
     
    text-align: center;

    a {
        color: ${fixedColors.RC_ACTION} !important;
        text-decoration: none !important;

        &:hover {
            color: ${fixedColors.RC_ACTION} !important;
            text-decoration: none !important;
        }
    }
`;

const ButtonContainer = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 25px;
    box-sizing: border-box;
`;

const Button = styled.button`
    flex: 1;
    max-width: 111px;
    background-color: ${({ primaryColor }) => ((primaryColor) ? `#${primaryColor}` : fixedColors.RC_ROYAL)};
    cursor: pointer;
    padding: 15px 0;
    border: none;
    border-radius: 7px;
    color: #ffffff;
    font-size: 13px !important;

    &:first-child {
      margin-right: 15px;
    }
`;
// End of style

const ConfirmZone = ({
  webappConfig, mainColor, location,
  setZoneAry, setZoneStr, setFullAddress, history
}) => {
  const { main_color } = mainColor;
  const {
    has_wgw: hasWgw, has_calendar: hasCalendar
  } = webappConfig || {
    has_wgw: false, has_calendar: false
  };

  const { zoneList, confirmText, prevRoute } = location.state;

  const [textContent, setTextContent] = useState('');

  const confirmHandler = async () => {
    try {
      setZoneAry(zoneList.zoneAry);
      setZoneStr(zoneList.zoneString);
      setFullAddress(zoneList.fullAddress);

      // Set the schedule and collection
      const collectionScheduleStatus = await setCollectionSchedule(zoneList.zoneString);

      if (collectionScheduleStatus !== 'done') throw new Error('There was a problem in setting schedule and collections, in confirmHandler function at utils.');

      let route = '';
      route = ((!prevRoute || !prevRoute.prevRoute) && hasCalendar) ? '/cal' : '';
      route = ((!prevRoute || !prevRoute.prevRoute) && !hasCalendar && hasWgw) ? '/wgw' : '';
      route = ((!prevRoute || !prevRoute.prevRoute) && !hasCalendar && !hasWgw) ? '/resources' : '';
      route = (prevRoute === '/help' || prevRoute.prevRoute === '/help') ? '/help/missed-collections' : '';
      history.push(route);

      return 'done';
    } catch (e) {
      return Promise.reject(e.message);
    }
  };

  useEffect(() => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    setTextContent(confirmText.replace(urlRegex, (url) => `<a href="${url}" target="_blank">${url}</a>`));
  }, []);

  return (
    <Container>
      <Text>{parse(textContent)}</Text>
      <ButtonContainer>
        <Button primaryColor={main_color} onClick={() => confirmHandler()}>{_('general.continue')}</Button>
        <Button primaryColor={main_color} onClick={() => history.goBack()}>{_('general.cancel')}</Button>
      </ButtonContainer>
    </Container>
  );
};

const mapStateToProps = (store) => ({
  mainColor: store.config.templateColour ? JSON.parse(store.config.templateColour) : {},
  webappConfig: store.config.webappConfig,
});

const mapDispatchToProps = (dispatch) => ({
  setZoneAry: (zoneAry) => dispatch(zoneSetup.setZoneAry(zoneAry)),
  setZoneStr: (zoneStr) => dispatch(zoneSetup.setZoneStr(zoneStr)),
  setFullAddress: (fullAddress) => dispatch(zoneSetup.setFullAddress(fullAddress)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmZone));
